import { CircularProgress } from "@mui/material";
import { Button } from "react-admin";

export default function CustomButtonSubmit({ ...props }) {
  const { label } = props;
  let sx = props.sx;
  let disabled = props?.disabled;
  if (sx == "" || sx == null || sx == undefined) {
    sx = {
      width: "120px",
      textTransform: "uppercase",
    };
  }
  return (
    <Button
      type="submit"
      label={label ? label : "Submit"}
      endIcon={
        label == "loading" ? (
          <CircularProgress size={16} color="inherit" />
        ) : null
      }
      variant="contained"
      size="medium"
      color={props.color ? props.color : "primary"}
      sx={{ ...sx }}
      disabled={disabled}
    />
  );
}
